import React from "react"
import {Button} from "@mui/material"
import AddIcon from "@mui/icons-material/Add"

import {CreateOfferModal} from "./CreateOfferModal/CreateOfferModal"
import {CreateOfferModalV2} from "./CreateOfferModal/CreateOfferModalV2"

type CreateOfferButtonProps = {
	customerID: string
	onSuccess: () => void
	enableOneOffOffers?: boolean
	enablePlanOffers?: boolean
	minInstalmentAmount?: number
}

function CreateOfferButton({
	customerID,
	onSuccess,
	enableOneOffOffers = true,
	enablePlanOffers = false,
	minInstalmentAmount = 10,
}: CreateOfferButtonProps) {
	const [createModalOpen, setCreateModalOpen] = React.useState(false)
	const useV2Modal = new URLSearchParams(window.location.search).get("useOfferModalV2") === "true"

	const handleSuccess = () => {
		setCreateModalOpen(false)
		onSuccess()
	}

	const ModalComponent = useV2Modal ? CreateOfferModalV2 : CreateOfferModal

	return (
		<>
			<Button
				variant="outlined"
				color="primary"
				startIcon={<AddIcon />}
				onClick={() => setCreateModalOpen(true)}
				size="small"
			>
				CREATE OFFER
			</Button>
			{createModalOpen && (
				<ModalComponent
					customerID={customerID}
					onClose={() => setCreateModalOpen(false)}
					onSuccess={handleSuccess}
					enableOneOffOffers={enableOneOffOffers}
					enablePlanOffers={enablePlanOffers}
					minInstalmentAmount={minInstalmentAmount}
				/>
			)}
		</>
	)
}

export {CreateOfferButton}
